import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/look.svg'
import _imports_1 from '@/assets/svg/edit.svg'
import _imports_2 from '@/assets/svg/unionDel.svg'


const _withScopeId = n => (_pushScopeId("data-v-3e461494"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "right_content" }
const _hoisted_3 = { class: "mod_wrap mod_set_wrap" }
const _hoisted_4 = { class: "mod_c_title flex between" }
const _hoisted_5 = { class: "mod_c_tbody select_none" }
const _hoisted_6 = { class: "container_textLeft" }
const _hoisted_7 = { class: "picture_btn" }
const _hoisted_8 = { class: "establish_table" }
const _hoisted_9 = { class: "establich_punsh" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "establish_circles" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "push" }, "草稿", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "establich_punsh" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "establish_circle" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "push" }, "已发布", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "establich_punsh" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "establish_circles" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "push" }, "未发布", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "liveList_out" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_28 = { class: "mod_pagin establish_pagation" }

import { Input, DatePicker, Pagination, Table, Button, message } from 'ant-design-vue';
import { computed, reactive, ref, unref, watch } from 'vue';
import { RightOutlined, SearchOutlined } from '@ant-design/icons-vue';
import { ColumnProps } from 'ant-design-vue/es/table/interface';
import CDelModal from '@/components/CDelModal.vue';
import detailList from './detailList.vue';
import Crumb from '@/components/Crumb.vue';
import http from '@/api/conentCenter/communal';
import moment from 'moment';
import emitter from '@/utils/mitt';
// 二级菜单、底部栏
import CMenu from '../components/CLeftMenu.vue';
import CMove from '../components/CMoveSort.vue';
import CAddCategoryVue from '../components/CAddCategory.vue';
import { useStore } from 'vuex';
import { onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';
import { useRoute } from 'vue-router';
import { moveSort, createSort } from './sortFunction';
type Key = ColumnProps['key'];
interface DataType {
  created_at: string;
  id: number;
  publisher: string;
  release_status: number;
  sort_name: string;
  title: string;
  sort_id: number;
  release_time: string;
}
//弹框删除按钮

export default /*#__PURE__*/_defineComponent({
  __name: 'articleList',
  setup(__props) {

const route = useRoute();
const aInputSearch = Input.Search;
const { RangePicker } = DatePicker;
const aRangePicker = RangePicker;
const aPagination = Pagination;
const aButton = Button;
const aTable = Table;
const modalVisible = ref(false);
const showLoading = ref<boolean>(false); //loading
const checked_all = ref(false);
const createGift = ref(true);
const ranges: any = {
  今天: [moment().startOf('day'), moment().endOf('day')],
  最近一周: [moment().startOf('day').subtract(1, 'weeks'), moment()],
  最近一月: [moment().startOf('day').subtract(1, 'months'), moment()],
  最近三月: [moment().startOf('day').subtract(3, 'months'), moment()],
};

const getCreateStatus = (data: any) => {
  createGift.value = data;
  createStatus.value = 1;
  portalArticleList();
};
// 全选
const setSelectAll = () => {
  if (checked_all.value) {
    let data: any = [];
    datafol.value.map((res) => {
      data.push(res.id);
    });
    onSelectChange([...data]);
  } else {
    onSelectChange([]);
  }
};
//删除按钮
const openDelModal = () => {
  // id重复，清空数组
  let data: any = [];
  datafol.value.map((res) => {
    data.push(res.id);
  });
  modalVisible.value = true;
};

const selectedRowKeys = ref<Key[]>([]);
selectedRowKeys.value = [];
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
  checked_all.value = selectedRowKeys.value.length == datafol.value.length ? true : false;
  emitSelectedRowKeys();
};
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});
//表格头
const columns = [
  {
    title: '标题名称',
    dataIndex: 'title',
    width: '15%',
    fixed: 'left',
    align: 'left',
    ellipsis: true,
  },
  {
    title: '发布人',
    dataIndex: 'publisher',
    width: '11%',
  },
  {
    title: '发布状态',
    dataIndex: 'release_status',
    width: '12%',
    slots: {
      customRender: 'release_status',
    },
    align: 'left',
    ellipsis: true,
  },
  {
    title: '所属分类',
    dataIndex: 'sort_name',
    width: '11%',
    ellipsis: true,
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    width: '15%',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '发布时间',
    dataIndex: 'release_time',
    width: '15%',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '操作',
    dataIndex: 'portalHandle',
    fixed: 'right',
    width: '16%',
    align: 'center',
    slots: {
      customRender: 'portalHandle',
    },
  },
];
//表格数据
const datafol = ref<DataType[]>([]);
const openDelModat = () => {
  modalVisible.value = false;
  selectedRowKeys.value = [];
  checked_all.value = false;
};
////弹框确认按钮
const removeLiveData = () => {
  createStatus.value = 0;
  const params = {
    id: selectedRowKeys.value.join(','),
    portal_id: gatewayId,
  };
  http.getDelPortalArticle({ params: params }).then(() => {
    portalArticleList();
    createStatus.value = 1;
    selectedRowKeys.value = [];
    checked_all.value = false;
    message.success('删除成功!');
    emitSelectedRowKeys();
  });
  modalVisible.value = false;
};
//表格删除按钮
const tabDel = (record: any) => {
  // 获取id
  selectedRowKeys.value = [];
  selectedRowKeys.value.push(record.id);
  modalVisible.value = true;
};
// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 1, // 总数
  options: ['12', '24', '36', '48', '60'], // 选项
});
const createId = ref();
const editId = ref();
const portalId = ref();
const passId = ref();

// 创建
const goList = () => {
  createGift.value = false;
  createStatus.value = 0;
  editId.value = 1;
};
// 查看
const golook = (item: any) => {
  createGift.value = false;
  createId.value = item.id;
  editId.value = 3;
  portalId.value = gatewayId;
};

// 编辑
const goEdit = (item: any) => {
  createGift.value = false;
  createId.value = item.id;
  editId.value = 2;
  portalId.value = gatewayId;
  createStatus.value = 0;
};
// const childMethod = () => {
//   portalArticleList();
// };
const gatewayId = route.params.gatewayId;
const moveSortId = ref();
const getMoveSortId = (data: any) => {
  moveSortId.value = data;
};
/**
 * 移动分类
 */
const emitSelectedRowKeys = () => {
  emitter.emit('selectedRowKeys', selectedRowKeys.value);
};

const childRef = ref();
const { isMove, moveStatus, createMove } = moveSort({
  type: 1,
  gatewayId: gatewayId,
});
watch(
  () => moveStatus.value,
  () => {
    moveStatus.value == 1 && portalArticleList();
  }
);

const moveCategory = () => {
  isMove.value = true;
};
const closeMove = () => {
  isMove.value = !isMove.value;
};

/** */

/**
 * 添加分类
 */
const { isVisible, createStatus, getCreate } = createSort({
  gatewayId: gatewayId,
});

const addCategory = () => {
  isVisible.value = true;
};
const isopenDelModal = () => {
  isVisible.value = !isVisible.value;
};
/** */

// 根据sortId去筛选文章列表; 分类id   sortId等于分类的id
const sortId = ref();
const sortInfo = ref();
const getSortInfo = (data: any) => {
  sortInfo.value = data;
  sortId.value = data.id;
  portalArticleList();
  operation.use_time_filter = [];
};

// 处理底部导致侧边栏出现滚动条的情况
const store = useStore();
const selectedKeys = ref<string[]>([]);
store.commit('home/setCustomFooter', true);
const customData = computed(() => store.state.home.customData);
const customFootStyle = computed(() => store.state.home.customFootStyle);
onBeforeRouteUpdate((to) => {
  selectedKeys.value = [to.path];
});
onBeforeRouteLeave(() => {
  store.commit('home/setCustomFooter', false);
});

const operation = reactive({
  use_time_filter: ref([]), // 使用记录时间筛选
  inputSearch: '',
});
// 获取文章列表
const releaseStatus = ref();
const portalArticleList = () => {
  checked_all.value = false;
  showLoading.value = true;
  let portal = {
    keyword: operation.inputSearch,
    start_at: operation.use_time_filter[0] ? new Date(operation.use_time_filter[0]) : operation.use_time_filter[0],
    end_at: operation.use_time_filter[1] ? new Date(operation.use_time_filter[1]) : operation.use_time_filter[1],
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
    sort_id: sortId.value,
    portal_id: gatewayId,
  };
  http.getPortalArticleList({ params: portal }).then((res) => {
    pageConfig.current = res.data.data.current_page;
    pageConfig.totalSize = res.data.data.total;
    const degree = res.data.data;
    datafol.value = [...degree.data];
    showLoading.value = false;
    datafol.value.forEach((item) => {
      passId.value = item.sort_id;
      releaseStatus.value = item.release_status;
    });
  });
  selectedRowKeys.value = [];
};

// 禁止选中、右键
const body: any = document.querySelector('body');
body.setAttribute('oncontextmenu', 'return false');
body.setAttribute('style', 'user-select:none');

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Crumb),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CMenu, {
          "data-source": { menuType: 1, createSort: _unref(createStatus), moveSort: _unref(moveStatus) },
          onSortInfo: getSortInfo
        }, null, 8, ["data-source"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createTextVNode(" 文章分类 / "),
                _withDirectives(_createElementVNode("span", { class: "sub_title" }, _toDisplayString(sortInfo.value?.name) + "(" + _toDisplayString(sortInfo.value?.count) + ")", 513), [
                  [_vShow, sortInfo.value?.name]
                ])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_unref(aButton), { onClick: moveCategory }, {
                  default: _withCtx(() => [
                    _createTextVNode("移至分类"),
                    _createVNode(_unref(RightOutlined))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(aButton), {
                  class: "mod_btn_primary actived",
                  onClick: addCategory
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加分类")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(aRangePicker), {
                    ranges: ranges,
                    "show-time": { format: 'HH:mm' },
                    format: "YYYY-MM-DD HH:mm",
                    value: operation.use_time_filter,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((operation.use_time_filter) = $event)),
                    class: "mod_range_picker",
                    onChange: portalArticleList,
                    onOk: portalArticleList
                  }, {
                    suffixIcon: _withCtx(() => [
                      _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createVNode(_unref(aInputSearch), {
                    class: "mod_range_picker_search",
                    placeholder: "请输入标题名称",
                    onSearch: portalArticleList,
                    value: operation.inputSearch,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((operation.inputSearch) = $event))
                  }, {
                    enterButton: _withCtx(() => [
                      _createVNode(_unref(SearchOutlined))
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createVNode(_unref(aButton), {
                    class: "establish_button",
                    type: "primary",
                    onClick: goList
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("创建")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_a_checkbox, {
                    class: "select",
                    checked: checked_all.value,
                    "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((checked_all).value = $event)),
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (setSelectAll()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("全选")
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  _createVNode(_unref(aButton), {
                    type: "link",
                    danger: "",
                    class: "mod_btn",
                    disabled: selectedRowKeys.value.length == 0,
                    onClick: openDelModal
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        class: "mod_btn_icon",
                        "icon-class": "del"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" 删除 ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createVNode(CDelModal, {
                visible: modalVisible.value,
                centered: "",
                close: openDelModat,
                ok: removeLiveData
              }, null, 8, ["visible"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(aTable), {
                loading: showLoading.value,
                "row-selection": _unref(rowSelection),
                columns: columns,
                "data-source": datafol.value,
                pagination: false,
                class: "liveList_w",
                rowKey: 
          (res) => {
            return res.id;
          }
        
              }, {
                release_status: _withCtx(({ record }) => [
                  _withDirectives(_createElementVNode("div", _hoisted_9, _hoisted_12, 512), [
                    [_vShow, record.release_status === 0]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_13, _hoisted_16, 512), [
                    [_vShow, record.release_status === 1]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_17, _hoisted_20, 512), [
                    [_vShow, record.release_status === 2]
                  ]),
                  _createTextVNode(" " + _toDisplayString(record.text), 1)
                ]),
                portalHandle: _withCtx(({ record }) => [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("a", {
                      centered: "",
                      onClick: ($event: any) => (golook(record))
                    }, [
                      _hoisted_23,
                      _createTextVNode(" " + _toDisplayString(record.text), 1)
                    ], 8, _hoisted_22),
                    _createElementVNode("a", {
                      centered: "",
                      onClick: ($event: any) => (goEdit(record))
                    }, [
                      _hoisted_25,
                      _createTextVNode(" " + _toDisplayString(record.text), 1)
                    ], 8, _hoisted_24),
                    _createElementVNode("a", {
                      centered: "",
                      onClick: ($event: any) => (tabDel(record))
                    }, [
                      _hoisted_27,
                      _createTextVNode(" " + _toDisplayString(record.text), 1)
                    ], 8, _hoisted_26)
                  ])
                ]),
                _: 1
              }, 8, ["loading", "row-selection", "data-source", "rowKey"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              (datafol.value.length !== 0)
                ? (_openBlock(), _createBlock(_unref(aPagination), {
                    key: 0,
                    "show-quick-jumper": "",
                    total: pageConfig.totalSize,
                    current: pageConfig.current,
                    "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => ((pageConfig.current) = $event)),
                    "page-size": pageConfig.pageSize,
                    "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((pageConfig.pageSize) = $event)),
                    pageSizeOptions: pageConfig.options,
                    "show-less-items": "",
                    "show-size-changer": "",
                    onChange: portalArticleList,
                    onShowSizeChange: portalArticleList
                  }, null, 8, ["total", "current", "page-size", "pageSizeOptions"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _withDirectives(_createElementVNode("div", { class: "mod_footer" }, _toDisplayString(_unref(customData).copyright), 513), [
            [_vShow, _unref(customFootStyle)]
          ])
        ])
      ])
    ], 512), [
      [_vShow, createGift.value]
    ]),
    (!createGift.value)
      ? (_openBlock(), _createBlock(detailList, {
          key: 0,
          onCreateStatus: getCreateStatus,
          data: { id: createId.value, click: editId.value, date: portalId.value, sortId: sortId.value, createSort: _unref(createStatus) }
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    _createVNode(CAddCategoryVue, {
      visible: _unref(isVisible),
      close: isopenDelModal,
      ok: _unref(getCreate),
      centered: ""
    }, null, 8, ["visible", "ok"]),
    _createVNode(CMove, {
      ref_key: "childRef",
      ref: childRef,
      "data-source": { menuType: 1, moveStatus: _unref(moveStatus) },
      visible: _unref(isMove),
      close: closeMove,
      ok: _unref(createMove),
      onMoveSortId: getMoveSortId,
      centered: "",
      onSortInfo: getSortInfo
    }, null, 8, ["data-source", "visible", "ok"])
  ], 64))
}
}

})